import * as React from 'react'
import { createRoot } from 'react-dom/client'

import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const startRhythmBot = async () => {
	const container = document.getElementById('root')
	const root = createRoot(container)

	const Routes = (await import('./routes/Ionic/index.js')).Routes

	root.render(<Routes />)

	serviceWorkerRegistration.register({
		onUpdate: (registration) => {
			if (registration && registration.waiting) {
				registration.waiting.postMessage({ type: 'SKIP_WAITING' })
			}
		},
	})
}

startRhythmBot()
